import { useState, useEffect } from "react";

const useInfiniteScroll = (callback, refEl) => {
  const [isFetching, setIsFetching] = useState(false);

	const handleScroll = (event) => {
		if (event.deltaY > 0) {
			const { scrollTop, scrollHeight, clientHeight } = refEl.current;
			setIsFetching((scrollHeight - clientHeight) <= (scrollTop + 30));
		}
  }

  useEffect(() => {
		if (refEl?.current) {
    	refEl.current.addEventListener("wheel", handleScroll);
		}
    return () => {
			if (refEl?.current) {
				refEl.current.removeEventListener("wheel", handleScroll);
			}
		};
  }, [refEl]);

  useEffect(() => {
		if (isFetching) {
			callback();
		}
  }, [isFetching]);

  return [isFetching, setIsFetching];
};

export default useInfiniteScroll;
